import { FormikProps, FormikValues } from 'formik';
import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Button as ReactButton } from '@a-ui/react';
import Box from '../../../components/Box';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { DetailLayout } from '../../../components/DetailLayout';
import { FormErrors } from '../../../components/Form';
import Form from '../../../components/Form/Form';
import PasswordField from '../../../components/PasswordField';
import Typography from '../../../components/Typography';
import { api } from '../../../hooks/api.hooks';
import { translate } from '../../../i18n';
import { useAuthentication } from '../../../state/Authentication';
import { useMessage } from '../../../state/Message';
import { setMessage } from '../../../state/Message/actions';
import { initialValues, validationSchema } from './config';

interface EmailDeleteProps {}

const EmailDelete: React.FC<EmailDeleteProps> = () => {
  const form = useRef<FormikProps<FormikValues>>(null);
  const [isModalVisible, setModalVisible] = React.useState(false);
  const history = useHistory();
  const { dispatch } = useMessage();
  const { refreshUser } = useAuthentication();

  const handleCancel = () => {
    history.push('/gegevens');
  };

  const toggleModal = () => {
    setModalVisible(!isModalVisible);
  };

  const cancelModal = () => {
    toggleModal();

    form.current!.setSubmitting(false);
  };

  const handleConfirm = async () => {
    toggleModal();

    await api.delete('/access-keys/email');
    await refreshUser();

    form.current!.setSubmitting(false);
    dispatch(setMessage('accessKeys.email.delete.success', 'accessKeysOverview', 'success'));
    history.push('/gegevens');
  };

  return (
    <DetailLayout
      title="accessKeys.email.delete.title"
      description="accessKeys.email.delete.intro"
      backAction="/gegevens"
      backLabel="accessKeys.overview.title"
    >
      <Box>
        <Form
          initialValues={initialValues}
          onSubmit={toggleModal}
          validationSchema={validationSchema}
          ref={form}
          preventAutoValidation
        >
          {({ isSubmitting }) => (
            <>
              <Typography variant="h2" as="h6" classNames="u-margin-bottom">
                {translate('accessKeys.password.subtitle')}
              </Typography>

              <FormErrors />

              <PasswordField
                label={translate('input.label.password')}
                name="password"
                classNames="u-margin-bottom"
              />

              <ul className="m-button-list u-margin-top">
                <li>
                  <ReactButton fullWidth htmlType="submit" disabled={isSubmitting}>
                    {translate('accessKeys.email.delete.submit')}
                  </ReactButton>
                </li>
                <li>
                  <ReactButton emphasis="medium" fullWidth onClick={handleCancel}>
                    {translate('common.button.cancel')}
                  </ReactButton>
                </li>
              </ul>
            </>
          )}
        </Form>

        <ConfirmationModal
          title="accessKeys.email.delete.modal.title"
          body="accessKeys.email.delete.modal.description"
          confirmLabel="accessKeys.email.delete.modal.confirm"
          cancelLabel="common.modal.cancel"
          onRequestClose={cancelModal}
          onConfirm={handleConfirm}
          isOpen={isModalVisible}
          variant="danger"
        />
      </Box>
    </DetailLayout>
  );
};

export default EmailDelete;
